import { NEW_CHECKLIST_SECTIONS } from "@ambulance/shared";

// Every item starts UNMARKED (""), forcing the crew to actively set
// ✓ / ✗ / N/A for each row before submitting.
function emptyMarks(
  items: ReadonlyArray<readonly [string, string, ...string[]]>
) {
  return Object.fromEntries(items.map((t) => [t[0], ""])) as Record<
    string,
    string
  >;
}

export function buildInitialChecklist() {
  const sections: Record<string, Record<string, string>> = {};
  for (const sec of NEW_CHECKLIST_SECTIONS) {
    sections[sec.key] = emptyMarks(sec.items);
    sections[sec.extraKey] = emptyMarks(sec.items);
  }
  return {
    hospitalId: "",
    ambulanceNo: "",
    date: new Date().toISOString().slice(0, 10),
    // Start unselected so the crew must actively choose (all mandatory).
    shift: "" as "" | "D" | "N",
    type: "" as "" | "I" | "II" | "III",
    level: "" as "" | "BLS" | "ALS" | "CC",
    mileage: "",
    externalNote: "",

    vehicleMechanical: sections.vehicleMechanical,
    vehicleMechanicalRemarks: sections.vehicleMechanicalRemarks,
    medicalEquipment: sections.medicalEquipment,
    medicalEquipmentRemarks: sections.medicalEquipmentRemarks,
    aclsItems: sections.aclsItems,
    aclsExpiry: sections.aclsExpiry,
    aclsSealNumber: "",
    compAirway: sections.compAirway,
    compAirwayExpiry: sections.compAirwayExpiry,
    compBreathing: sections.compBreathing,
    compBreathingExpiry: sections.compBreathingExpiry,
    compCirculation: sections.compCirculation,
    compCirculationExpiry: sections.compCirculationExpiry,
    compInfection: sections.compInfection,
    compInfectionExpiry: sections.compInfectionExpiry,
    compImmobilization: sections.compImmobilization,
    compImmobilizationExpiry: sections.compImmobilizationExpiry,
    compOb: sections.compOb,
    compObExpiry: sections.compObExpiry,

    handover: {
      outgoingName: "",
      outgoingId: "",
      outgoingSignature: "",
      incomingName: "",
      incomingId: "",
      incomingSignature: "",
    } as Record<string, string>,

    submittedByName: "",
  };
}

export type ChecklistFormState = ReturnType<typeof buildInitialChecklist>;
